module.exports = __webpack_public_path__ + "static/assets/0ecdb4dd6cfb7d7ee5a9b10e09325fad.png";